/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BackupResponse } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * BackupApi - axios parameter creator
 * @export
 */
export const BackupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a complete backup of agent data and send to backup server  **Process:** 1. Check if agent exists and user has permission 2. Check if backup server is configured 3. Collect all agent data (contexts, APIs, settings, etc.) 4. Send data to backup server in background 5. Return immediate response  **Required Permission:** agent:edit  **Returns:** Backup response with summary
         * @summary Create backup for an agent and send to backup server
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBackup: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('createBackup', 'agentId', agentId)
            const localVarPath = `/api/v1/backup/create/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a complete backup of agent data and send to backup server  **Process:** 1. Check if agent exists and user has permission 2. Check if backup server is configured 3. Collect all agent data (contexts, APIs, settings, etc.) 4. Send data to backup server in background 5. Return immediate response  **Required Permission:** agent:edit  **Returns:** Backup response with summary
         * @summary Create backup for an agent and send to backup server
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBackup_1: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('createBackup_1', 'agentId', agentId)
            const localVarPath = `/api/v1/backup/create/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Force backup for an agent - Super Admin only  This endpoint allows super admin to manually trigger a full backup regardless of the schedule. Useful for disaster recovery scenarios.  **Required Permission:** Super Admin  **Returns:** Confirmation message
         * @summary Force backup for an agent (Super Admin only)
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceBackup: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('forceBackup', 'agentId', agentId)
            const localVarPath = `/api/v1/backup/force/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Force backup for an agent - Super Admin only  This endpoint allows super admin to manually trigger a full backup regardless of the schedule. Useful for disaster recovery scenarios.  **Required Permission:** Super Admin  **Returns:** Confirmation message
         * @summary Force backup for an agent (Super Admin only)
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceBackup_2: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('forceBackup_2', 'agentId', agentId)
            const localVarPath = `/api/v1/backup/force/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get backup configuration status for an agent  **Returns:** - isBackupEnabled: boolean - backupServerURL: string (if configured) - hasBackupCredentials: boolean
         * @summary Get backup configuration status for an agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackupStatus: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getBackupStatus', 'agentId', agentId)
            const localVarPath = `/api/v1/backup/status/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get backup configuration status for an agent  **Returns:** - isBackupEnabled: boolean - backupServerURL: string (if configured) - hasBackupCredentials: boolean
         * @summary Get backup configuration status for an agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackupStatus_3: async (agentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getBackupStatus_3', 'agentId', agentId)
            const localVarPath = `/api/v1/backup/status/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2PasswordBearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2PasswordBearer", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BackupApi - functional programming interface
 * @export
 */
export const BackupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BackupApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a complete backup of agent data and send to backup server  **Process:** 1. Check if agent exists and user has permission 2. Check if backup server is configured 3. Collect all agent data (contexts, APIs, settings, etc.) 4. Send data to backup server in background 5. Return immediate response  **Required Permission:** agent:edit  **Returns:** Backup response with summary
         * @summary Create backup for an agent and send to backup server
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBackup(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBackup(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.createBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a complete backup of agent data and send to backup server  **Process:** 1. Check if agent exists and user has permission 2. Check if backup server is configured 3. Collect all agent data (contexts, APIs, settings, etc.) 4. Send data to backup server in background 5. Return immediate response  **Required Permission:** agent:edit  **Returns:** Backup response with summary
         * @summary Create backup for an agent and send to backup server
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBackup_1(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBackup_1(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.createBackup_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Force backup for an agent - Super Admin only  This endpoint allows super admin to manually trigger a full backup regardless of the schedule. Useful for disaster recovery scenarios.  **Required Permission:** Super Admin  **Returns:** Confirmation message
         * @summary Force backup for an agent (Super Admin only)
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forceBackup(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forceBackup(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.forceBackup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Force backup for an agent - Super Admin only  This endpoint allows super admin to manually trigger a full backup regardless of the schedule. Useful for disaster recovery scenarios.  **Required Permission:** Super Admin  **Returns:** Confirmation message
         * @summary Force backup for an agent (Super Admin only)
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forceBackup_2(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forceBackup_2(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.forceBackup_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get backup configuration status for an agent  **Returns:** - isBackupEnabled: boolean - backupServerURL: string (if configured) - hasBackupCredentials: boolean
         * @summary Get backup configuration status for an agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBackupStatus(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBackupStatus(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.getBackupStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get backup configuration status for an agent  **Returns:** - isBackupEnabled: boolean - backupServerURL: string (if configured) - hasBackupCredentials: boolean
         * @summary Get backup configuration status for an agent
         * @param {string} agentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBackupStatus_3(agentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBackupStatus_3(agentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BackupApi.getBackupStatus_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BackupApi - factory interface
 * @export
 */
export const BackupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BackupApiFp(configuration)
    return {
        /**
         * Create a complete backup of agent data and send to backup server  **Process:** 1. Check if agent exists and user has permission 2. Check if backup server is configured 3. Collect all agent data (contexts, APIs, settings, etc.) 4. Send data to backup server in background 5. Return immediate response  **Required Permission:** agent:edit  **Returns:** Backup response with summary
         * @summary Create backup for an agent and send to backup server
         * @param {BackupApiCreateBackupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBackup(requestParameters: BackupApiCreateBackupRequest, options?: RawAxiosRequestConfig): AxiosPromise<BackupResponse> {
            return localVarFp.createBackup(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a complete backup of agent data and send to backup server  **Process:** 1. Check if agent exists and user has permission 2. Check if backup server is configured 3. Collect all agent data (contexts, APIs, settings, etc.) 4. Send data to backup server in background 5. Return immediate response  **Required Permission:** agent:edit  **Returns:** Backup response with summary
         * @summary Create backup for an agent and send to backup server
         * @param {BackupApiCreateBackup0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBackup_1(requestParameters: BackupApiCreateBackup0Request, options?: RawAxiosRequestConfig): AxiosPromise<BackupResponse> {
            return localVarFp.createBackup_1(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Force backup for an agent - Super Admin only  This endpoint allows super admin to manually trigger a full backup regardless of the schedule. Useful for disaster recovery scenarios.  **Required Permission:** Super Admin  **Returns:** Confirmation message
         * @summary Force backup for an agent (Super Admin only)
         * @param {BackupApiForceBackupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceBackup(requestParameters: BackupApiForceBackupRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.forceBackup(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Force backup for an agent - Super Admin only  This endpoint allows super admin to manually trigger a full backup regardless of the schedule. Useful for disaster recovery scenarios.  **Required Permission:** Super Admin  **Returns:** Confirmation message
         * @summary Force backup for an agent (Super Admin only)
         * @param {BackupApiForceBackup0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceBackup_2(requestParameters: BackupApiForceBackup0Request, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.forceBackup_2(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get backup configuration status for an agent  **Returns:** - isBackupEnabled: boolean - backupServerURL: string (if configured) - hasBackupCredentials: boolean
         * @summary Get backup configuration status for an agent
         * @param {BackupApiGetBackupStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackupStatus(requestParameters: BackupApiGetBackupStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getBackupStatus(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get backup configuration status for an agent  **Returns:** - isBackupEnabled: boolean - backupServerURL: string (if configured) - hasBackupCredentials: boolean
         * @summary Get backup configuration status for an agent
         * @param {BackupApiGetBackupStatus0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBackupStatus_3(requestParameters: BackupApiGetBackupStatus0Request, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getBackupStatus_3(requestParameters.agentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createBackup operation in BackupApi.
 * @export
 * @interface BackupApiCreateBackupRequest
 */
export interface BackupApiCreateBackupRequest {
    /**
     * 
     * @type {string}
     * @memberof BackupApiCreateBackup
     */
    readonly agentId: string
}

/**
 * Request parameters for createBackup_1 operation in BackupApi.
 * @export
 * @interface BackupApiCreateBackup0Request
 */
export interface BackupApiCreateBackup0Request {
    /**
     * 
     * @type {string}
     * @memberof BackupApiCreateBackup0
     */
    readonly agentId: string
}

/**
 * Request parameters for forceBackup operation in BackupApi.
 * @export
 * @interface BackupApiForceBackupRequest
 */
export interface BackupApiForceBackupRequest {
    /**
     * 
     * @type {string}
     * @memberof BackupApiForceBackup
     */
    readonly agentId: string
}

/**
 * Request parameters for forceBackup_2 operation in BackupApi.
 * @export
 * @interface BackupApiForceBackup0Request
 */
export interface BackupApiForceBackup0Request {
    /**
     * 
     * @type {string}
     * @memberof BackupApiForceBackup0
     */
    readonly agentId: string
}

/**
 * Request parameters for getBackupStatus operation in BackupApi.
 * @export
 * @interface BackupApiGetBackupStatusRequest
 */
export interface BackupApiGetBackupStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof BackupApiGetBackupStatus
     */
    readonly agentId: string
}

/**
 * Request parameters for getBackupStatus_3 operation in BackupApi.
 * @export
 * @interface BackupApiGetBackupStatus0Request
 */
export interface BackupApiGetBackupStatus0Request {
    /**
     * 
     * @type {string}
     * @memberof BackupApiGetBackupStatus0
     */
    readonly agentId: string
}

/**
 * BackupApi - object-oriented interface
 * @export
 * @class BackupApi
 * @extends {BaseAPI}
 */
export class BackupApi extends BaseAPI {
    /**
     * Create a complete backup of agent data and send to backup server  **Process:** 1. Check if agent exists and user has permission 2. Check if backup server is configured 3. Collect all agent data (contexts, APIs, settings, etc.) 4. Send data to backup server in background 5. Return immediate response  **Required Permission:** agent:edit  **Returns:** Backup response with summary
     * @summary Create backup for an agent and send to backup server
     * @param {BackupApiCreateBackupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public createBackup(requestParameters: BackupApiCreateBackupRequest, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).createBackup(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a complete backup of agent data and send to backup server  **Process:** 1. Check if agent exists and user has permission 2. Check if backup server is configured 3. Collect all agent data (contexts, APIs, settings, etc.) 4. Send data to backup server in background 5. Return immediate response  **Required Permission:** agent:edit  **Returns:** Backup response with summary
     * @summary Create backup for an agent and send to backup server
     * @param {BackupApiCreateBackup0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public createBackup_1(requestParameters: BackupApiCreateBackup0Request, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).createBackup_1(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Force backup for an agent - Super Admin only  This endpoint allows super admin to manually trigger a full backup regardless of the schedule. Useful for disaster recovery scenarios.  **Required Permission:** Super Admin  **Returns:** Confirmation message
     * @summary Force backup for an agent (Super Admin only)
     * @param {BackupApiForceBackupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public forceBackup(requestParameters: BackupApiForceBackupRequest, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).forceBackup(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Force backup for an agent - Super Admin only  This endpoint allows super admin to manually trigger a full backup regardless of the schedule. Useful for disaster recovery scenarios.  **Required Permission:** Super Admin  **Returns:** Confirmation message
     * @summary Force backup for an agent (Super Admin only)
     * @param {BackupApiForceBackup0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public forceBackup_2(requestParameters: BackupApiForceBackup0Request, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).forceBackup_2(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get backup configuration status for an agent  **Returns:** - isBackupEnabled: boolean - backupServerURL: string (if configured) - hasBackupCredentials: boolean
     * @summary Get backup configuration status for an agent
     * @param {BackupApiGetBackupStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public getBackupStatus(requestParameters: BackupApiGetBackupStatusRequest, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).getBackupStatus(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get backup configuration status for an agent  **Returns:** - isBackupEnabled: boolean - backupServerURL: string (if configured) - hasBackupCredentials: boolean
     * @summary Get backup configuration status for an agent
     * @param {BackupApiGetBackupStatus0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public getBackupStatus_3(requestParameters: BackupApiGetBackupStatus0Request, options?: RawAxiosRequestConfig) {
        return BackupApiFp(this.configuration).getBackupStatus_3(requestParameters.agentId, options).then((request) => request(this.axios, this.basePath));
    }
}

